import { Component, OnInit, ElementRef } from '@angular/core';
import { ROUTES } from '../sidebar/sidebar.component';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth/auth.service';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  restroName: any;
  sidebarVisible: boolean = false;


  constructor(location: Location, private element: ElementRef, private router: Router, private authService: AuthService) {

    this.sidebarVisible = false;

  }

  ngOnInit() {
    this.sidebarVisible = false
    this.restroName = localStorage.getItem('resname') ? localStorage.getItem('resname') : 'N/A'
  }
  closseFunction() {
    localStorage.clear()
    this.router.navigate([this.authService.getLoginUrl()]);
  }

  sidebarOpen() {

    this.sidebarVisible = true;
  };
  sidebarClose() {

    this.sidebarVisible = false;

  };


}
